import React from 'react'
import { match, Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'

import { createFeature, Features } from '@app/Feature'
import { CourtCaseProvider } from '@app/modules/CourtCases/Components/CourtCaseContext/CourtCaseContext'
import { CourtCaseTabNames, getCourtCasePath } from '@app/modules/CourtCases/paths'
import { CourtCaseChatPage } from '@app/modules/CourtCases/routes/CourtCaseChatPage'
import { CourtCaseInvoicingPage } from '@app/modules/CourtCases/routes/CourtCaseInvoicingPage'

export const CourtCases = () => {
  const match: match<{ id: string; courtCaseUuid: string }> = useRouteMatch()
  const customerId = Number(match.params.id)
  const courtCaseUuid = match.params.courtCaseUuid

  return (
    <CourtCaseProvider>
      <Switch>
        <Route
          path={getCourtCasePath(':id', ':courtCaseUuid', CourtCaseTabNames.ChatChronic)}
          component={CourtCaseChatPage}
          exact
        />
        <Route
          path={getCourtCasePath(':id', ':courtCaseUuid', CourtCaseTabNames.Invoicing)}
          component={createFeature({
            name: Features.COURT_CASE_INVOICING,
            route: true,
            fallback: (
              <Redirect
                to={getCourtCasePath(customerId, courtCaseUuid, CourtCaseTabNames.ChatChronic)}
              />
            )
          })(CourtCaseInvoicingPage)}
          exact
        />
        <Redirect to={getCourtCasePath(customerId, courtCaseUuid, CourtCaseTabNames.ChatChronic)} />
      </Switch>
    </CourtCaseProvider>
  )
}
